export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7759.47f8a34b.jpg";